/**
 * childFormatter — comment on NOMME l'enfant dans ce que le parent lit.
 *
 * Le prénom vient de l'enfant affiché ; à défaut, du compte connecté — qui EST l'élève en mode
 * parent ; à défaut encore, on parle de « votre enfant », comme le legacy.
 */

/** Le legacy nomme l'élève, ou parle de « votre enfant » quand le prénom manque. */
export const DEFAULT_CHILD_NAME = "votre enfant"

export function childDisplayName(
    childFirstname?: string | null,
    user?: { firstname?: unknown } | null | undefined
): string {
    const fromUser = typeof user?.firstname === "string" ? user.firstname : ""
    return (childFirstname ?? "").trim() || fromUser.trim() || DEFAULT_CHILD_NAME
}

/**
 * Le mot qui précède le prénom, élidé devant une voyelle : « de André » → « d'André », « que Inès »
 * → « qu'Inès ». Le H initial est traité comme une voyelle (« d'Hugo »), Y aussi (« d'Yasmine ») :
 * les h aspirés sont assez rares pour que le compromis inverse soit faux plus souvent. Seul le e
 * final tombe — « à » ou « pour » passent tels quels. Un prénom vide rend le mot seul.
 *
 * Jumeaux : `common/utils/activationSuiteDisplay.js` (legacy) et `TextHelper::elide()` (back-end),
 * même liste de voyelles.
 */
export function elide(name: string | null | undefined, preposition = "de"): string {
    const trimmed = (name ?? "").trim()
    if (!trimmed) return preposition

    // Les diacritiques comptent : « Émile » commence bien par une voyelle.
    const elided = preposition.endsWith("e") && /^[aeiouyhàâäéèêëîïôöùûü]/i.test(trimmed)

    return elided ? `${preposition.slice(0, -1)}'${trimmed}` : `${preposition} ${trimmed}`
}
